import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
  getOrderWiseStatus,
  getOrderDetails,
  orderAccept,
  orderCancel
} from '@/api/online-ordering/website-ordering/order-request'

export const fetchOrderWiseStatus = createAsyncThunk(
  'orderStatus/fetchAll',
  async (params, { rejectWithValue }) => {
    const res = await getOrderWiseStatus(params)
    if (res.status === 'success') return res.data
    return rejectWithValue(res.message)
  }
)

export const fetchOrderDetails = createAsyncThunk(
  'orderStatus/fetchDetails',
  async (orderId, { rejectWithValue }) => {
    const res = await getOrderDetails(orderId)
    if (res.status === 'success') return res.data
    return rejectWithValue(res.message)
  }
)

export const acceptOrder = createAsyncThunk(
  'orderStatus/acceptOrder',
  async (orderId, { rejectWithValue }) => {
    const res = await orderAccept(orderId)
    if (res.status === 'success') return res.data
    return rejectWithValue(res.message)
  }
)

export const cancelOrder = createAsyncThunk(
  'orderStatus/cancelOrder',
  async (orderId, { rejectWithValue }) => {
    const res = await orderCancel(orderId)
    if (res.status === 'success') return res.data
    return rejectWithValue(res.message)
  }
)

// Initial State

const initialState = {
  orders: [],
  orderDetails: null,
  pagination: null,
  getLoading: false,
  updateLoading: false,
  error: null,
  success: null
}

// Slice

const orderStatusSlice = createSlice({
  name: 'orderStatus',
  initialState,
  reducers: {
    clearOrderMessages: state => {
      state.error = null
      state.success = null
    },
    addNewOnlineOrder: (state, action) => {
      state.orders = [action.payload, ...state.orders]
    },
    replaceOnlineOrder: (state, action) => {
      const index = state.orders.findIndex(order => order.id === action.payload.id)
      if (index !== -1) {
        state.orders[index] = action.payload
      }
    }

  },
  extraReducers: builder => {
    builder
      .addCase(fetchOrderWiseStatus.pending, state => {
        state.getLoading = true
        state.error = null
      })
      .addCase(fetchOrderWiseStatus.fulfilled, (state, action) => {
        state.getLoading = false
        state.orders = action.payload.orders
        state.pagination = action.payload.pagination
      })
      .addCase(fetchOrderWiseStatus.rejected, (state, action) => {
        state.getLoading = false
        state.error = action.payload
      })
      .addCase(fetchOrderDetails.pending, state => {
        state.getLoading = true
        state.error = null
      })
      .addCase(fetchOrderDetails.fulfilled, (state, action) => {
        state.getLoading = false
        state.orderDetails = action.payload
      })
      .addCase(fetchOrderDetails.rejected, (state, action) => {
        state.getLoading = false
        state.error = action.payload
      })
      .addCase(acceptOrder.pending, state => {
        state.updateLoading = true
        state.error = null
        state.success = null
      })
      .addCase(acceptOrder.fulfilled, (state, action) => {
        state.updateLoading = false
        state.orderDetails = action.payload
        state.success = 'Order accepted successfully'
      })
      .addCase(acceptOrder.rejected, (state, action) => {
        state.updateLoading = false
        state.error = action.payload
      })
      .addCase(cancelOrder.pending, state => {
        state.updateLoading = true
        state.error = null
        state.success = null
      })
      .addCase(cancelOrder.fulfilled, (state, action) => {
        state.updateLoading = false
        state.orderDetails = action.payload
        state.success = 'Order canceled successfully'
      })
      .addCase(cancelOrder.rejected, (state, action) => {
        state.updateLoading = false
        state.error = action.payload
      })
  }
})
export const { clearOrderMessages, addNewOnlineOrder, replaceOnlineOrder } = orderStatusSlice.actions
export default orderStatusSlice.reducer
